import { useContext, useEffect, useState } from 'react';
import { Group, Loader, Text } from '@mantine/core';
import AppContext from '../AppContext';

import { ListItemSelector } from '../../shared/ListItemSelector';
import { useTranslation } from 'react-i18next';

interface ItemInterface {
    id: number,
    value: string
}

interface PropsInterface {
    handle: any
}

const JobSelector = ({handle}: PropsInterface) => {
    
    const myContext = useContext(AppContext);
  const { t } = useTranslation();
    const [isLoaded,setIsLoaded] = useState(myContext.jobs === null ? false : true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (isLoaded) return;
        if (isError) return;
        myContext.httpClient.get(`${myContext.apiAddress}/get_repository_job`).then((res: any) => {
            if (res.data.status === true) {
                myContext.setJobs({
                    label: 'Métiers',
                    date: (new Date()).getTime(),
                    items: res.data.data,
                });
                setIsLoaded(true);
            } else {
                setIsError(true);
            }
        });
    }); // eslint-disable-line

    if (!isLoaded || myContext.jobs === null) {
        return (
            <Group>
                <Loader />
                <Text>Chargement des métiers</Text>
            </Group>
        )
    }
    
    const handleSelection = (items: ItemInterface[]) => {
        handle(items);
    }

    return (
        <ListItemSelector
            title={t("common.selectJob")}
            items={myContext.jobs.items.map((i: any) => { return { id: i.id, value: i.label} })}
            handleSelection={handleSelection}
            multi={true}
        />
    )
}

export { JobSelector }